export default __webpack_public_path__ + "static/media/keto-chocolate-bar@2x.1eae5737.png";